import { render, staticRenderFns } from "./newBotPostFinish.vue?vue&type=template&id=bb9d1cac&"
import script from "./newBotPostFinish.vue?vue&type=script&lang=js&"
export * from "./newBotPostFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports